import { computed, ref, watch } from "vue";
import { toValue } from "@vueuse/core";
import { useBillingCycles } from "@/features/subscribe/composables/useBillingCycles.js";

const billingCycleToLabel = {
  "2-yearly": "2-Year",
  annually: "Annual",
  monthly: "Monthly",
};

export const useBillingCycle = () => {
  const selectedBillingCycle = ref("annually");

  const planCycles = useBillingCycles();

  watch(planCycles, (newValue) => {
    selectedBillingCycle.value = newValue[0];
  });

  const allBillingCycles = computed(() =>
    toValue(planCycles).map((cycle) => ({
      id: cycle,
      label: billingCycleToLabel[cycle],
    }))
  );

  return {
    allBillingCycles,
    selectedBillingCycle,
  };
};
